import actions from "./actions";
import {setErrorReducer, setRequestReducer, setSuccessReducer} from "../helper";

const initState = {
    financingSettingUpdateState: false,

    financingDashboardReadState: false,
    financingDashboard: {
        msic_code: null,
        consent_level: null,
        consented_at: null,
        loans: [],
    },
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.FINANCING_SETTINGS_UPDATE_REQUEST:
            return setRequestReducer(state, 'financingSettingUpdateState');
        case actions.FINANCING_SETTINGS_UPDATE_SUCCESS:
            return setSuccessReducer(state, 'financingSettingUpdateState', {
                financingDashboard: {
                    ...state.financingDashboard,
                    msic_code: action.msic_code,
                    consent_level: action.consent_level,
                    consented_at: action.consented_at,
                },
            });
        case actions.FINANCING_SETTINGS_UPDATE_ERROR:
            return setErrorReducer(state, 'financingSettingUpdateState');

        case actions.FINANCING_DASHBOARD_READ_REQUEST:
            return setRequestReducer(state, 'financingDashboardReadState');
        case actions.FINANCING_DASHBOARD_READ_SUCCESS:
            return setSuccessReducer(state, 'financingDashboardReadState', {
                financingDashboard: {
                    msic_code: action.data.msic_code,
                    consent_level: action.data.consent_level,
                    consented_at: action.data.consented_at,
                    loans: action.data.loans,
                },
            });
        case actions.FINANCING_DASHBOARD_READ_ERROR:
            return setErrorReducer(state, 'financingDashboardReadState');

        default:
            return state;
    }
}
